import { MutationTree } from 'vuex'
import { EventStateInterface } from 'src/store/event/state'
import { Event } from 'able-lib'
import { NEW_EVENT_TEMPLATE } from 'src/lib/constants'
import Vue from 'vue'

const mutation: MutationTree<EventStateInterface> = {
  UPDATE_EVENT_TITLE (state, name: Event): void {
    state.eventDraft.name = JSON.parse(JSON.stringify(name))
  },

  UPDATE_EVENT_START_DATE_TIME (state, start: Event): void {
    state.eventDraft.startDatetime = start
  },

  UPDATE_EVENT_END_DATE_TIME (state, end: Event): void {
    state.eventDraft.endDatetime = end
  },

  SET_EVENTS (state, events: Array<Event>): void {
    state.events = events
  },

  ADD_EVENT_ON_LIST (state, newEvent: Event): void {
    state.events.push(newEvent)
  },

  UPDATE_EVENT_ON_LIST (state, updatedEvent: Event): void {
    const eventIndex = state.events.findIndex(event => event.id === updatedEvent.id)
    Vue.set(state.events, eventIndex + '', updatedEvent)
  },

  SET_EVENT_DRAFT (state, event: Event): void {
    state.eventDraft = JSON.parse(JSON.stringify(event))
  },

  RESET_EVENT_DRAFT (state): void {
    state.eventDraft = JSON.parse(JSON.stringify(NEW_EVENT_TEMPLATE))
  }

}

export default mutation
